import { useEffect, useState } from 'react';

export type HeaderVariantType = 'transparent' | 'default';

type UseHeaderProps = {
  isHeaderChanges: boolean;
};

export function useHeader({ isHeaderChanges }: UseHeaderProps) {
  const [isFixed, setIsFixed] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const [lastScrollY, setLastScrollY] = useState<number>(0);

  const handleScroll = () => {
    let currentScrollY = window.scrollY;

    // Safari 탄성 스크롤 방지
    if (currentScrollY < 0) {
      currentScrollY = 0;
    }

    if (currentScrollY > lastScrollY) {
      // scroll down
      setIsVisible(false);
    } else {
      // scroll up
      setIsVisible(true);
    }

    setIsFixed(currentScrollY > 0);
    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHeaderChanges, lastScrollY]);

  /*
   * Publishes whether the header is on screen, so sticky content elsewhere can
   * sit right under it while it shows and move up when it slides away. The
   * attribute is absent until the first render, which reads as visible, the
   * way the header starts.
   */
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.headerVisible = String(isVisible);
    return () => {
      delete root.dataset.headerVisible;
    };
  }, [isVisible]);

  const checkVariant = (): HeaderVariantType => {
    if (!isHeaderChanges) {
      return 'default';
    }
    return !isFixed ? 'transparent' : 'default';
  };

  const variantStyle = checkVariant();

  return { isFixed, isVisible, variantStyle };
}
